module.exports = {
  painter: require('./painter'),
  getShape: require('./getShape')
};